const cartDrawer = document.querySelector("[data-cart-drawer]");
const cartOverlay = document.querySelector("[data-cart-drawer-overlay]");

function toggleCartDrawer() {
  document.body.classList.toggle("overflow-hidden");

  if (cartDrawer) {
    cartDrawer.classList.toggle("translate-x-full");
  }
  if (cartOverlay) {
    cartOverlay.classList.toggle("opacity-50");
    cartOverlay.classList.toggle("invisible");
  }
}

function addCartToggleEvents() {
  document.querySelectorAll("[data-cart-toggle]").forEach((el) => {
    el.removeEventListener("click", toggleCartDrawer);
    el.addEventListener("click", toggleCartDrawer);
  });
}

window.addEventListener("load", () => {
  addCartToggleEvents();
});
